import { useEffect, useState, useMemo } from 'react';
import { RoleSidebar } from './_Candidates/RoleSidebar';
import { CandidatesList } from './_Candidates/CandidatesList';
import { useLazyGetJobsByCompanyQuery } from '../../features/apis/intergration';
import useCurrentUser from '../../customHook/useCurrentUser';
import { useLazyGetResumesByCompanyIdQuery } from '../../features/apis/intergration';
import { useLazyGetCandidatesByCompanyIdQuery } from '../../features/apis/intergration';

export default function CandidatesDashboard() {
  const [selectedRole, setSelectedRole] = useState('');
  const [top, setTop] = useState(100);
  const [loading, setLoading] = useState(true);
  const [getJobsByCompany, { data: jobs }] = useLazyGetJobsByCompanyQuery();
  const [getCandidatesByCompanyId, { data: candidates }] =
    useLazyGetCandidatesByCompanyIdQuery();
  const [getResumesByCompanyId, { data: resumes }] =
    useLazyGetResumesByCompanyIdQuery();

  const user = useCurrentUser();

  useEffect(() => {
    if (!user?.companyId) return;

    setLoading(true);

    Promise.all([
      getJobsByCompany(user.companyId).unwrap(),
      getResumesByCompanyId(user.companyId).unwrap(),
      getCandidatesByCompanyId(user.companyId).unwrap(),
    ]).finally(() => setLoading(false));
  }, [
    getCandidatesByCompanyId,
    getJobsByCompany,
    getResumesByCompanyId,
    user?.companyId,
  ]);

  const filteredCandidates = useMemo(() => {
    if (!candidates?.length) return [];

    const normalizedRole = selectedRole?.toLowerCase();
    return [...candidates]
      .filter((candidate) => {
        if (!selectedRole) return true;

        const primary = candidate.primaryJob?.name?.toLowerCase() || '';
        const secondary =
          candidate.secondaryJobs?.map((j) => j.name?.toLowerCase()) || [];

        return primary === normalizedRole || secondary.includes(normalizedRole);
      })
      .sort((a, b) => (b?.primaryJob?.match ?? 0) - (a.primaryJob?.match ?? 0))
      .slice(0, top);
  }, [candidates, selectedRole, top]);

  return (
    <div className="flex flex-col lg:flex-row w-full min-h-full gap-4 font-inter min-w-0">
      {/* Sidebar */}
      <div className="w-full lg:w-1/4 flex-shrink-0">
        <RoleSidebar
          jobs={jobs}
          selectedRole={selectedRole}
          setSelectedRole={setSelectedRole}
          top={top}
          setTop={setTop}
          resumes={resumes?.resumes}
        />
      </div>

      <div className="w-full lg:w-3/4 flex-1">
        <CandidatesList
          peopleData={filteredCandidates}
          jobs={jobs}
          setSelectedRole={setSelectedRole}
          setTop={setTop}
          selectedRole={selectedRole}
          isLoading={loading}
          resumeStats={resumes?.resumeStats}
        />
      </div>
    </div>
  );
}
